module.exports = __webpack_public_path__ + "8fe2785dad65cb9ed8d10abb36b2b947.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/taiwan-16.png
// module id = 484
// module chunks = 0